var membership_popup = (function( $ ) {

	var _init = function() {
		if ( $( '.membership-popup' ).length > 0 ) {
			_setup_popup();
		}
	};

	var _setup_popup = function() {
		$( '.membership-popup' ).magnificPopup( {
			type: 'inline',
			preloader: false
		} );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = membership_popup;